import React from 'react';
import './ConfirmDialog.css';

interface ConfirmDialogProps {
  /** 是否显示对话框 */
  visible: boolean;
  /** 对话框标题 */
  title?: string;
  /** 对话框内容文本 */
  message: string;
  /** 确认按钮文本 */
  confirmText?: string;
  /** 取消按钮文本 */
  cancelText?: string;
  /** 确认按钮点击处理函数 */
  onConfirm: () => void;
  /** 取消按钮点击处理函数 */
  onCancel: () => void;
}

/**
 * 通用确认对话框组件
 * 
 * 用于显示确认信息，支持自定义标题、内容和按钮文本
 * 
 * @example
 * <ConfirmDialog
 *   visible={dialogVisible}
 *   message="确定要删除场次 [ 001 ] 吗？"
 *   onConfirm={handleConfirm}
 *   onCancel={handleCancel}
 * />
 */
const ConfirmDialog: React.FC<ConfirmDialogProps> = ({
  visible,
  title,
  message,
  confirmText = '确认',
  cancelText = '取消',
  onConfirm,
  onCancel
}) => {
  if (!visible) {
    return null;
  }

  // 处理遮罩层点击
  const handleOverlayClick = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget) {
      onCancel();
    }
  };

  return (
    <div className="confirm-dialog-overlay" onClick={handleOverlayClick}>
      <div className="confirm-dialog">
        {title && (
          <div className="confirm-dialog-header">
            <h3>{title}</h3>
          </div>
        )}
        
        <div className="confirm-dialog-content">
          <p>{message}</p>
        </div>
        
        <div className="confirm-dialog-actions">
          <button
            className="confirm-btn confirm-btn-cancel"
            onClick={onCancel}
          >
            {cancelText}
          </button>
          <button
            className="confirm-btn confirm-btn-confirm"
            onClick={onConfirm}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDialog;

